import * as React from 'react';
import { PageData } from '../../models/utilities/paged-request';

// #region Component Props

interface IProps {
    pageData: PageData;
    onFirstClick?: any;
    onPrevClick : any;
    onNextClick: any;
    onLastClick?: any;
}

// #endregion


export const TablePager = (props: IProps) => {

    function showFirstButton() {
        return props.onFirstClick && props.pageData.canSkip();
    }
    function showLastButton() {
        return props.onLastClick && props.pageData.canSkip();
    }

    return (props && props.pageData) ?
        <div className="table-pager">
            <div className="input-group">
                <div className="input-group-prepend">
                    {
                        showFirstButton() ? <button className="btn-icon prev"
                            disabled={!props.pageData || props.pageData.isPrevDisabled()}
                            onClick={props.onFirstClick}>
                            First <i className="la la-angle-double-left" />
                        </button> : null
                    }
                    <button className="btn-icon prev"
                        disabled={!props.pageData || props.pageData.isPrevDisabled()}
                        onClick={props.onPrevClick}>
                        Prev <i className="la la-chevron-circle-left" />
                    </button>
                </div>
                {
                    props.pageData.canSkip()
                        ? <input type="text" className="form-control" disabled={true} value={props.pageData.pageCount + " of " + props.pageData.totalPages} />
                        : <input type="text" className="form-control" disabled={true} value={props.pageData.pageCount} />
                }
                <div className="input-group-append">
                    <button className="btn-icon next"
                        disabled={!props.pageData || props.pageData.isNextDisabled()}
                        onClick={props.onNextClick}>
                        <i className="la la-chevron-circle-right" /> Next
                    </button>
                    {
                        showLastButton() ? <button className="btn-icon next"
                            disabled={!props.pageData || props.pageData.isNextDisabled()}
                            onClick={props.onLastClick}>
                            <i className="la la-angle-double-right" /> Last
                        </button> : null
                    }
                </div>
            </div>
        </div> : null

}